import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AntiquarioApp as Component } from "./app";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <Component />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
